import http from 'utils/http';
import { generateURLWithParams } from 'utils';

export const fetchAccessibleRoles = () => http.get('v1/user/organizations/roles/').then((res) => res.data);

export const fetchUsersPermissions = (params = {}) => {
  const { organizationId, ...query } = params;
  const basePath = organizationId
    ? `v1/user/organization/${organizationId}/users-permissions/`
    : 'v1/user/organization/{{organizationId}}/users-permissions/';
  const url = generateURLWithParams(basePath, query);
  return http.get(url).then((res) => res.data);
};

export const createNewUserPermission = ({
  email,
  roles,
  parents,
  access_all_parents,
  restaurants_administrated,
  organizationId,
  first_name,
  last_name,
}) => {
  const path = organizationId
    ? `v1/user/organization/${organizationId}/users-permissions/`
    : 'v1/user/organization/{{organizationId}}/users-permissions/';
  return http.post(path, {
    email,
    roles,
    parents,
    access_all_parents,
    restaurants_administrated,
    first_name,
    last_name,
  }).then((res) => res.data);
};

export const getUserPermissions = (userId) => http.get(`v1/user/organization/{{organizationId}}/users-permissions/${userId}/`).then((res) => res.data);

export const updateUserPermissions = ({
  userId, email, roles, parents, access_all_parents, restaurants_administrated,
}) => http.put(`v1/user/organization/{{organizationId}}/users-permissions/${userId}/`, {
  email,
  roles,
  parents,
  access_all_parents,
  restaurants_administrated,
}).then((res) => res.data);

export const deleteUserPermissions = (userId) => http.delete(`v1/user/organization/{{organizationId}}/users-permissions/${userId}/`).then((res) => res.data);
